// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"3922":"css/app.6980","4916":"css/admin-app.6980"}[chunkId] + ".css";
};